import React from 'react';

const SectionTitle = ({
  title,
  subtitle,
  centered = true,
  light = false,
  className = ''
}) => {
  return (
    <div className={`${centered ? 'text-center' : ''} mb-10 ${className}`}>
      <h2 className={`text-3xl md:text-4xl font-neuropolitical font-bold mb-3 ${light ? 'text-white' : 'text-gray-900'}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`text-lg max-w-2xl ${centered ? 'mx-auto' : ''} ${light ? 'text-white/80' : 'text-gray-600'}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionTitle;
